import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LocationSetTypesActions } from './location-set-types.actions';
import { LocationSetTypesSelectors } from './location-set-types.selectors';
import {LocationSetType} from '@emm/core/models/location-set-type.model';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';

export interface LocationSetTypesQueries extends AsyncActionQueries {
    displayResultsImmediately$: Observable<boolean>;
    isLocationSetTypeParent$: Observable<boolean>;
    onlyParents$: Observable<LocationSetType[]>;
    selected$: Observable<LocationSetType>;
}

@Injectable({
    providedIn: 'root'
})
export class LocationSetTypesStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>) {
        super(store, LocationSetTypesSelectors);
    }

    dispatch = {
        selectLocationSetType: (tag: string) =>
            this.store.dispatch(LocationSetTypesActions.select({ tag }))
    };

    queries: LocationSetTypesQueries = {
        onlyParents$: this.selectNonNil(LocationSetTypesSelectors.getValidOnlyParents),
        selected$: this.selectNonNil(LocationSetTypesSelectors.getSelected),
        ...this.asyncActionQueries,
        isLocationSetTypeParent$: this.select(LocationSetTypesSelectors.getIsLocationSetTypeParent),
        displayResultsImmediately$: this.selectNonNil(
            LocationSetTypesSelectors.getDisplayResultsImmediately
        )
    };

}
